import { locales } from '../locales_de'
export const config: {
  allHazards: string[]
  locales: {
    hazards: { [key: string]: string }
    levels: { slight: string; mean: string; substantial: string }
  }
  colors: {
    hazards: {
      [P in hazardNames]: {
        mean: string
        slight: string
        substantial: string
      }
    }
  }
} = {
  allHazards: ['water', 'avalanche', 'landslide', 'rockfall'],
  locales: locales,
  colors: require('../colors.json')
}
